var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/language-picker/x-country-picker.ts
import "@adornis/base/utilTypes.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { virtualize } from "@adornis/chemistry/directives/when-seen.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-card.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import { XDropdownSearchSelection } from "@adornis/popover/x-dropdown-search-selection.js";
import { Language } from "@adornis/translation-core/languages.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { state } from "lit/decorators/state.js";
import { filter, map } from "rxjs/operators";
import { getAllCountries, getFlagByLangAbbreviation } from "../../helpers/flag.js";
var XCountryPicker = class extends XDropdownSearchSelection {
  constructor() {
    super(...arguments);
    this.language = new RXController(this, Language.ENGLISH);
    this.allCountries = new RXController(
      this,
      this.language.observable.pipe(
        filter(Boolean),
        map((lang) => getAllCountries(lang))
      )
    );
    this.showflag = false;
    this.flagsize = 30;
    this.maxResults = void 0;
    this.search = (input) => Object.entries(this.allCountries.value ?? {}).filter(([key, val]) => {
      return !input || val.toUpperCase().startsWith(input.toUpperCase());
    }).map(([key, val]) => {
      return [key, val, this.showflag ? getFlagByLangAbbreviation(key) : ""];
    }).slice(0, this.maxResults);
    this.renderItem = ([short, country, flag]) => html`
    ${virtualize(
      html`
        <x-flex horizontal crossaxis-center padding="sm" space="sm" ${css({ cursor: "pointer", userSelect: "none" })}>
          ${flag ? html` <img ${css({ width: this.flagsize + "px", height: this.flagsize / 1.5 + "px" })} src="${flag}" /> ` : nothing}
          <x-text> ${country} </x-text>
        </x-flex>
      `,
      (oldHeight) => html` <div ${css({ height: `${oldHeight}px` })}></div> `,
      { wrapperDisplayContents: true }
    )}
  `;
    this.renderSelected = (selected) => {
      if (selected)
        return this.allCountries.value?.[selected] || "";
    };
    this.resolveID = (v) => v[0];
  }
  _choose(selectable) {
    this._adropdown?.close();
    this._preSelectedItem = -1;
    this.value.next(selectable[0] || selectable[1]);
  }
  mapSearch(values) {
    return values.map((val) => ["", val, ""]);
  }
};
__decorateClass([
  property()
], XCountryPicker.prototype, "language", 2);
__decorateClass([
  state()
], XCountryPicker.prototype, "allCountries", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], XCountryPicker.prototype, "showflag", 2);
__decorateClass([
  property({ type: Number })
], XCountryPicker.prototype, "flagsize", 2);
__decorateClass([
  property({ type: Number, attribute: "max-results" })
], XCountryPicker.prototype, "maxResults", 2);
XCountryPicker = __decorateClass([
  customElement("x-country-picker")
], XCountryPicker);
export {
  XCountryPicker
};
